import { render, staticRenderFns } from "./contactTodoComponent.vue?vue&type=template&id=42214cb2&"
import script from "./contactTodoComponent.vue?vue&type=script&lang=js&"
export * from "./contactTodoComponent.vue?vue&type=script&lang=js&"
import style0 from "./contactTodoComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAlert,VAvatar,VCard,VCardText,VCardTitle,VImg})
